"use client";

import { useEffect } from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => console.error(error), [error]);
  return <div className="flex min-h-[70dvh] items-center justify-center p-6"><div className="max-w-md text-center"><p className="text-xs font-semibold tracking-[.18em] text-destructive uppercase">Connection interrupted</p><h2 className="display-type mt-3 text-5xl">Try again.</h2><Button onClick={reset} className="mt-7"><RefreshCw data-icon="inline-start" /> Retry</Button></div></div>;
}
